export default __webpack_public_path__ + "static/summer_containers56-f79b7c1524d47730959a2a60ba579bb7.webp";